const WA_LINK =
  "https://wa.me/5581995913182?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20os%20servi%C3%A7os%20de%20advocacia%20previdenci%C3%A1ria";

// Navbar height on mobile ≈ 72px logo + 40px padding = 112px  →  +20px gap = 132px
const MOBILE_OFFSET = 132;

export default function Hero() {
  return (
    <>
      {/* Anchor for navigation — always present */}
      <div id="hero" className="absolute top-0 left-0 w-0 h-0 pointer-events-none" aria-hidden="true" />

      {/* ─── DESKTOP hero ─── */}
      <section
        className="relative min-h-screen w-full flex items-center overflow-hidden hidden md:flex"
      >
        {/* Background — new high-quality PNG */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/43ca9b65-54bc-436a-92a3-dc535ee093a8_aaaa.png?v=e27efae8ef51c7bb29074141bfd8f599"
            alt="Dra. Suellen Martins"
            className="w-full h-full object-cover"
            style={{ objectPosition: "right top" }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/10" />
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to bottom, rgba(0,0,0,0.28) 0%, rgba(122,44,30,0.05) 60%, rgba(213,143,117,0.08) 100%)",
            }}
          />
        </div>

        {/* Content — LEFT aligned */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-16 flex justify-start">
          <HeroContent />
        </div>
      </section>

      {/* ─── MOBILE hero — starts below navbar + 20px gap ─── */}
      <div
        className="md:hidden w-full flex flex-col"
        style={{ marginTop: `${MOBILE_OFFSET}px` }}
      >
        {/* Image — full height, no crop, contained */}
        <div
          className="relative w-full"
          style={{ backgroundColor: "rgb(40, 18, 14)" }}
        >
          <img
            src="https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/78820f84-09d8-4b14-b7ca-1df2b0c849f7_SUELLEN-MARTINS-FOTO.jpg?v=ee7d849391b2c5db851926da7c0a4a21"
            alt="Dra. Suellen Martins"
            className="w-full h-auto object-contain block"
          />
          {/* Subtle overlay for readability on image */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 pointer-events-none" />
        </div>

        {/* Content — below image, over dark bg */}
        <div
          className="w-full px-6 py-10 flex flex-col"
          style={{ backgroundColor: "rgb(40, 18, 14)" }}
        >
          <MobileHeroContent />
        </div>
      </div>
    </>
  );
}

/** Shared text/button content for desktop */
function HeroContent() {
  return (
    <div className="flex flex-col items-start text-left max-w-xl lg:max-w-2xl">
      <p className="font-body text-peach/90 text-xs tracking-[0.35em] uppercase mb-6 font-medium">
        Direito Previdenciário
      </p>

      <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-white font-semibold leading-tight mb-6">
        <span
          style={{
            textShadow:
              "2px 3px 12px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.9)",
          }}
        >
          Martins
        </span>{" "}
        <span
          className="text-peach font-light italic"
          style={{ textShadow: "1px 1px 5px rgba(0,0,0,0.45)" }}
        >
          Advocacia
        </span>
      </h1>

      <div className="w-12 h-px bg-peach/60 mb-8" />

      <p className="font-body text-white/75 text-lg md:text-xl font-light leading-relaxed mb-12 tracking-wide">
        Soluções previdenciárias com{" "}
        <span className="text-white font-medium">atenção</span>,{" "}
        <span className="text-white font-medium">estratégia</span> e{" "}
        <span className="text-white font-medium">cuidado</span>
      </p>

      <div className="flex flex-col sm:flex-row gap-4 items-start justify-start">
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="flex items-center gap-2.5 bg-peach text-white font-body font-semibold text-sm px-8 py-4 hover:bg-chestnut transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wide"
          style={{ borderRadius: "40px" }}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-whatsapp-line text-xl" />
          </div>
          Entre em contato agora
        </a>
      </div>
    </div>
  );
}

/** Mobile-only content block (below image) */
function MobileHeroContent() {
  return (
    <>
      <p className="font-body text-peach/90 text-xs tracking-[0.35em] uppercase mb-4 font-medium">
        Direito Previdenciário
      </p>

      <h1 className="font-display text-4xl text-white font-semibold leading-tight mb-5">
        Martins{" "}
        <span className="text-peach font-light italic">Advocacia</span>
      </h1>

      <div className="w-10 h-px bg-peach/60 mb-6" />

      <p className="font-body text-white/70 text-base font-light leading-relaxed mb-8 tracking-wide">
        Soluções previdenciárias com{" "}
        <span className="text-white font-medium">atenção</span>,{" "}
        <span className="text-white font-medium">estratégia</span> e{" "}
        <span className="text-white font-medium">cuidado</span>
      </p>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="inline-flex items-center gap-2.5 bg-peach text-white font-body font-semibold text-sm px-8 py-4 hover:bg-chestnut transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wide self-start"
        style={{ borderRadius: "40px" }}
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl" />
        </div>
        Entre em contato agora
      </a>
    </>
  );
}
